import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { TransportItemInterface, TransportListResponse } from '../../common/types/interfaces'

const initialState: { data: TransportListResponse } = {
  data: {
    data: [],
    total: 0,
  },
}

export const transportListSlice = createSlice({
  name: 'transport-list',
  initialState,
  reducers: {
    setTransportList: (state, action: PayloadAction<TransportListResponse>) => {
      state.data = { ...action.payload }
    },
    replaceTransportById: (state, action: PayloadAction<TransportItemInterface>) => {
      state.data = {
        ...state.data,
        data: [...state.data.data.filter((el) => el.id !== action.payload.id)],
      }
      state.data = { ...state.data, data: [...state.data.data, action.payload] }
    },
    removeTransportById: (state, action: PayloadAction<number>) => {
      state.data = {
        ...state.data,
        data: [...state.data.data.filter((el) => el.id !== action.payload)],
      }
    },
  },
})

export const { setTransportList } = transportListSlice.actions
export const { replaceTransportById } = transportListSlice.actions
export const { removeTransportById } = transportListSlice.actions

export const selectTransportList = (state: RootState) => state.transportList.data
export const selectTransportItem = (state: RootState, id: number) =>
  state.transportList.data.data.find((el) => el.id === id)

export default transportListSlice.reducer
